import { Markdown } from '@cadstrom/sigma-engine-shared';

import { PdfCitationMarkdownItem } from '#components/pdf-citation/pdf-citation-markdown-item.js';
import { BasicRemarkPlugin } from './markdown-plugins-utils.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

const definition = Markdown.PdfCitationMarkdownDirectiveDefinition;

/** Remark renderer for inline `:pdf-citation[…]` directives. */
export const pdfCitationMarkdownItemDefinition: RemarkMarkdownDirectiveDefinition<typeof definition> = {
	allowedAttributes: definition.allowedAttributes,
	directive: BasicRemarkPlugin(definition.directive, definition.nodeTypes, {
		contentPropName: definition.contentAttributeName,
	}),
	item: PdfCitationMarkdownItem,
};
